import React, { useState, useEffect, useRef } from "react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import CustomUploadAdapter from "./CustomUploadAdapter";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const CreateProducts = () => {
  const [show, setShow] = useState(false);
  const [sku, setsku] = useState("");
  const [productName, setName] = useState("");
  const [urlvideo, seturlvideo] = useState("");
  const [retailprice, setretailprice] = useState(Number);
  const [warrantyPeriod, sewarrantyPeriod] = useState("");
  const [originalPrice, setoriginalPrice] = useState(Number);
  const [sellingPrice, setsellingPrice] = useState(Number);
  const [quantity, setquantity] = useState(999);
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64Image, setBase64Image] = useState(null);
  const [base64Images, setBase64Images] = useState([]);
  const [status, setChecked] = React.useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [contactToPurchase, setcontactToPurchase] = React.useState(Boolean);
  const [bestseller, setbestseller] = React.useState(Boolean);
  const [brandId, setbrandId] = useState("");
  const [category, setcategory] = useState([]);
  const [parentCategoryID1, setParentCategoryID1] = useState([]);
  const [parentCategoryID2, setparentCategoryID2] = useState([]);
  const [parentCategori, setparentCategori] = useState([]);
  const [parentCategories, setparentCategories] = useState("");
  const [categoryId, setcategoryId] = useState("");
  const [description, setDescription] = useState("");
  const [description1, setDescription1] = useState("");
  const editorRef = useRef(null);
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [brands, setbrands] = useState([]);
  const [skuError, setSkuError] = useState("");
  const [productNameError, setProductNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [originalPriceError, setOriginalPriceError] = useState("");
  const [sellingPriceError, setSellingPriceError] = useState("");
  const [retailpriceError, setretailpriceError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [categoryIdError, setCategoryIdError] = useState("");
  const [brandIdError, setBrandIdError] = useState("");
  const [warrantyPeriodError, setWarrantyPeriodError] = useState("");
  const [SpecificationsError, setSpecificationsError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const page = params.get("page") || 1;

  const handleKeyPress = (event) => {
    const validKeys = /[0-9\b\r,.]/; // Allow digits, backspace, return, comma, and period
    if (!validKeys.test(event.key)) {
      event.preventDefault();
    }
  };
  const handleInput1 = (e, setVariable) => {
    const inputText = e.target.value;
    const numericValue = parseFloat(inputText.replace(/[^0-9.]+/g, "")); // Allow decimals
    setVariable(isNaN(numericValue) ? 0 : numericValue);
  };

  const handleKeyPress1 = (event) => {
    const validKeys = /[0-9\b\r]/;
    if (!validKeys.test(event.key)) {
      event.preventDefault();
    }
  };
  const handleInput = (e, setVariable) => {
    const inputText = e.target.value;

    // Loại bỏ mọi ký tự không phải số để tránh lỗi tiếng Việt hoặc ký tự khác
    const numericText = inputText.replace(/\D/g, "");

    // Giá trị gốc (không định dạng)
    const rawValue = numericText.replace(/^0+/, ""); // Loại bỏ số 0 ở đầu

    // Nếu không có số, đặt giá trị rỗng
    if (!rawValue) {
      setVariable("");
      e.target.value = "";
      return;
    }

    // Định dạng với dấu chấm phân cách mỗi 3 chữ số
    const formattedValue = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Lưu giá trị gốc vào state, hiển thị giá trị định dạng trên input
    setVariable(rawValue);
    e.target.value = formattedValue;
  };

  const handleChange = () => {
    setChecked(!status);
  };
  const handleChange1 = () => {
    setcontactToPurchase(!contactToPurchase);
  };
  const handleChange122 = () => {
    setbestseller(!bestseller);
  };
  const [productData, setProductData] = useState({
    sku: "",
    productName: "",
    originalPrice: 0,
    sellingPrice: 0,
    status: true,
    description: "",
    urlvideo: "",
    retailprice: "",
    quantity: 999,
    brandId: "",
    categoryId: "",
    warrantyPeriod: "",
    contactToPurchase: false,
    technicalSpecifications: [],
    images: [],
    parentCategories: [],
  });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/brands/getbrands`)
      .then((response) => response.json())
      .then((data) => {
        setbrands(data.brands);
        console.log("data", data.brands);
      })
      .catch((error) => console.log(error));
    fetch(`${process.env.REACT_APP_API_URL}/api/categories/getall`)
      .then((response) => response.json())
      .then((data) => {
        setcategory(data);
      })
      .catch((error) => console.log(error));

    setProductData((prevProductData) => ({
      ...prevProductData,
      description: description1.trim(),
      sku: sku.trim(),
      urlvideo: urlvideo.trim(),
      productName: productName.trim(),
      originalPrice:
        typeof originalPrice === "string"
          ? parseFloat(
              originalPrice
                .replace(/[^\d.]+/g, "")
                .replace(".", "")
                .replace(",", ".")
            )
          : originalPrice,
      sellingPrice:
        typeof sellingPrice === "string"
          ? parseFloat(
              sellingPrice
                .replace(/[^\d.]+/g, "")
                .replace(".", "")
                .replace(",", ".")
            )
          : sellingPrice,
      retailprice:
        typeof retailprice === "string"
          ? parseFloat(
              retailprice
                .replace(/[^\d.]+/g, "")
                .replace(".", "")
                .replace(",", ".")
            )
          : retailprice,
      quantity: quantity,
      brandId: brandId,
      categoryId: categoryId,
      warrantyPeriod: warrantyPeriod.trim(),
      contactToPurchase: contactToPurchase,
      status: status,
      bestseller: bestseller,
    }));
  }, [
    retailprice,
    description,
    sku,
    productName,
    originalPrice,
    sellingPrice,
    quantity,
    brandId,
    warrantyPeriod,
    contactToPurchase,
    status,
    urlvideo,
    bestseller,
  ]);

  useEffect(() => {
    async function fetchData() {
      if (categoryId) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/categories/getid/${categoryId}`
          );
          const dataFromAPI = await response.json();
          // console.log("dataFromAPI", dataFromAPI);
          // console.log("parentCategoryID", dataFromAPI.parentCategoryID);

          const newData = {
            categoryID: dataFromAPI.categoryID,
            name: dataFromAPI.name,
            parentCategoryID: dataFromAPI.parentCategoryID,
          };

          // Update parentCategoryID1
          setParentCategoryID1((prevParentCategoryID1) => [
            ...prevParentCategoryID1,
            newData,
          ]);
          // Perform the second API call
          if (dataFromAPI.parentCategoryID) {
            const response2 = await fetch(
              `${process.env.REACT_APP_API_URL}/api/categories/getid/${dataFromAPI.parentCategoryID}`
            );
            const dataFromAPI2 = await response2.json();
            const newData2 = {
              categoryID: dataFromAPI2.categoryID,
              name: dataFromAPI2.name,
              parentCategoryID: dataFromAPI2.parentCategoryID,
            };

            // Update parentCategoryID2
            setparentCategoryID2((prevParentCategoryID2) => [
              ...prevParentCategoryID2,
              newData2,
            ]);

            console.log("newData2", newData2);

            // Update the ProductData state
            setProductData((prevProductData) => ({
              ...prevProductData,
              parentCategories: [
                ...prevProductData.parentCategories,
                newData,
                newData2,
              ],
            }));
          }
        } catch (error) {
          console.log(error);
        }
      }
    }

    fetchData();
  }, [categoryId]);

  const handleNameChange67 = (event) => {
    const selectedCategoryId = event.target.value;
    setProductData((prevProductData) => ({
      ...prevProductData,
      parentCategories: [], // Reset parentCategories to an empty array
    }));
    setcategoryId(selectedCategoryId);
  };

  const [imagess, setimagess] = useState([]);
  // const handleFileSelect = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const base64Data = e.target.result;
  //       setBase64Image(base64Data);
  //       setSelectedFile(base64Data)
  //       const newImage = {
  //         srcData: base64Data,
  //         cardinal: true,
  //       };
  //       const newImages = [newImage];
  //       const updatedProductData = {
  //         ...productData,
  //         images: newImages,
  //       };
  //       setProductData(updatedProductData);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    handleFile(file);
  };

  const handleFileDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  const handleFile = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Data = e.target.result;
        setBase64Image(base64Data);
        setSelectedFile(base64Data);
        const newImage = {
          srcData: base64Data,
          cardinal: true,
        };
        const newImages = [newImage];
        const updatedProductData = {
          ...productData,
          images: newImages,
        };
        setProductData(updatedProductData);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleFileSelects = (event) => {
    const files = Array.from(event.target.files);
    handleFiles(files);
  };

  const handleFiles = (files) => {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Data = e.target.result;

        setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, file]);
        setBase64Images((prevBase64Images) => [
          ...prevBase64Images,
          base64Data,
        ]);

        setimagess((prevImages) => [
          ...prevImages,
          {
            srcData: base64Data,
            cardinal: false,
          },
        ]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleClearFile = (index) => {
    setSelectedFiles((prevSelectedFiles) => {
      const newFiles = [...prevSelectedFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });

    setBase64Images((prevBase64Images) => {
      const newBase64Images = [...prevBase64Images];
      newBase64Images.splice(index, 1);
      return newBase64Images;
    });

    setimagess((prevImages) => {
      const newImages = [...prevImages];
      newImages.splice(index, 1);
      return newImages;
    });
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    handleFiles(droppedFiles);
  };

  const handleNameChange = (e) => {
    setsku(e.target.value);
  };
  const handleNameChange1 = (e) => {
    setName(e.target.value);
  };
  const handleNameChange13 = (e) => {
    seturlvideo(e.target.value);
  };
  const handleNameChange11 = (e) => {
    sewarrantyPeriod(e.target.value);
  };

  const handleNameChangev = (e) => {
    setbrandId(e.target.value);
  };

  const handleEditorChange = (event, editor) => {
    try {
      let data = editor.getData();
      setDescription(data);
    } catch (error) {
      console.error("Error in handleEditorChange:", error);
    }
  };

  useEffect(() => {
    const updatedDescription = description
      .replace(/<p>([^<]+)<\/p>/g, '<span class="content">$1</span>')
      .replace(
        /<p>([^<]+<strong>[^<]+<\/strong>[^<]+)<\/p>/g,
        '<span class="content">$1</span>'
      )
      .replace(/<p>([\s\S]+?)<\/p>/g, '<span class="content">$1</span>')
      .replace(/Base64 Image/, "")
      .replace(
        /<figure class="image"><img src="([^"]+)"><figcaption>([^<]+)<\/figcaption><\/figure>/g,
        '<div class="frame-image"><img src=$1 alt=\'\' /><p class="title">$2</p></div>'
      )
      .replace(
        /<h2><strong>([^<]+)<\/strong><\/h2>/g,
        '<div class="title"><strong>$1</strong></div>'
      )
      .replace(
        /<figure class="image"><img src="([^"]+)">(?:<figcaption>([^<]+)<\/figcaption>)?<\/figure>/g,
        '<div class="frame-image"><img src= $1 alt=\'\' /><p class="title">$2</p></div>'
      )
      .replace(
        /<figure class="image">(.+?)<\/figure>/g,
        '<div class="frame-image">$1</div>'
      )
      .replace(
        /<figcaption>([\s\S]*?)<\/figcaption>/g,
        '<p class="title">$1</p>'
      )
      .replace(
        /<img src="([^"]+)" alt="([^"]+)">/g,
        '<div class="frame-image"><img src="$1"alt=""/><p class="title">$2</p></div>'
      )
      .replace(
        /<span class="content"><img src="([^"]+)" alt=""><\/span>/g,
        '<div class="frame-image">\n  <img src="$1" alt="" />\n  <p class= "title"></p>\n</div>'
      )
      //h2
      .replace(/<h2>(.*?)<\/h2>/g, '<div class="title">$1</div>')
      .replace(
        /<h[2-4]><strong>([^<]+)<\/strong>([^<]+)<\/h[2-4]>/g,
        '<div class="title"><strong>$1</strong>$2</div>'
      )
      .replace(
        /<h[2-4]>([^<]+)<strong>([^<]+)<\/strong>([^<]+)<\/h[2-4]>/,
        '<div class="title">$1<strong>$2</strong>$3</div>'
      )
      .replace(
        /<h[2-4]>([^<]+)<strong>([^<]+)<\/strong><\/h[2-4]>/,
        '<div class="title">$1<strong>$2</strong></div>'
      )
      .replace(/<h2>([^<]+)<\/h2>/, '<div class="title">$1</div>')
      //h3
      .replace(/<h3>(.*?)<\/h3>/g, '<div class="title">$1</div>')
      .replace(
        /<h3><strong>([^<]+)<\/strong>([^<]+)<\/h3>/g,
        '<div class="title"><strong>$1</strong>$2</div>'
      )
      .replace(
        /<h3>([^<]+)<strong>([^<]+)<\/strong>([^<]+)<\/h3>/g,
        '<div class="title">$1<strong>$2</strong>$3</div>'
      )
      .replace(
        /<h3>([^<]+)<strong>([^<]+)<\/strong><\/h3>/g,
        '<div class="title">$1<strong>$2</strong></div>'
      )
      .replace(/<h3>([^<]+)<\/h3>/g, '<div class="title">$1</div>')
      //h4
      .replace(/<h4>(.*?)<\/h4>/g, '<div class="title">$1</div>')
      .replace(
        /<h4><strong>([^<]+)<\/strong>([^<]+)<\/h4>/g,
        '<div class="title"><strong>$1</strong>$2</div>'
      )
      .replace(
        /<h4>([^<]+)<strong>([^<]+)<\/strong>([^<]+)<\/h4>/g,
        '<div class="title">$1<strong>$2</strong>$3</div>'
      )
      .replace(
        /<h4>([^<]+)<strong>([^<]+)<\/strong><\/h4>/g,
        '<div class="title">$1<strong>$2</strong></div>'
      )
      .replace(/<h4>([^<]+)<\/h4>/g, '<div class="title">$1</div>')
      .replace(
        /<figure class="image">([\s\S]+?)<\/figure>/g,
        '<div class="frame-image"><img src="base 64"alt=""/><p class="title"></p></div>'
      );

    setDescription1(updatedDescription);
  }, [description]);

  const handleCreate = () => {
    // Prepare the technical specifications from 'data'
    const specsToAdd = data.map((item) => ({
      title: item.title.trim(),
      content: item.content.trim(),
    }));

    // Filter out empty specifications
    const nonEmptySpecsToAdd = specsToAdd.filter(
      (spec) => spec.title.trim() !== "" || spec.content.trim() !== ""
    );

    // Combine existing technical specifications with the new ones
    const updatedTechnicalSpecifications = [
      ...productData.technicalSpecifications,
      ...nonEmptySpecsToAdd,
    ];

    // Prepare the updated product data with combined images and specifications
    const updatedProductData = {
      ...productData,
      images: [...productData.images, ...imagess],
      technicalSpecifications: updatedTechnicalSpecifications,
    };

    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let isValid = true;
    if (!sku) {
      setSkuError("Vui lòng nhập SKU");
      isValid = false;
    } else {
      setSkuError("");
    }

    if (!productName) {
      setProductNameError("Vui lòng nhập Tên Sản Phẩm");
      isValid = false;
    } else {
      setProductNameError("");
    }

    if (!description) {
      setDescriptionError("Vui lòng nhập Mô Tả");
      isValid = false;
    } else {
      setDescriptionError("");
    }
    if (retailprice === 0 || retailprice === "0") {
      setretailpriceError("Vui lòng nhập Giá Bán Lẻ");
      isValid = false;
    } else {
      setretailprice("");
    }
    if (!originalPrice) {
      setOriginalPriceError("Vui lòng nhập Giá Gốc");
      isValid = false;
    } else {
      setOriginalPriceError("");
    }

    if (!sellingPrice) {
      setSellingPriceError("Vui lòng nhập Giá Bán");
      isValid = false;
    } else {
      setSellingPriceError("");
    }

    if (!quantity) {
      setQuantityError("Vui lòng nhập Số Lượng");
      isValid = false;
    } else {
      setQuantityError("");
    }

    if (!categoryId) {
      setCategoryIdError("Vui lòng chọn Loại Sản Phẩm");
      isValid = false;
    } else {
      setCategoryIdError("");
    }

    if (!brandId) {
      setBrandIdError("Vui lòng chọn Hãng Sản Xuất");
      isValid = false;
    } else {
      setBrandIdError("");
    }

    if (!warrantyPeriod) {
      setWarrantyPeriodError("Vui lòng nhập Thời Gian Bảo Hành");
      isValid = false;
    } else {
      setWarrantyPeriodError("");
    }
    if (
      updatedTechnicalSpecifications.some(
        (spec) => spec.title === "" || spec.content === ""
      )
    ) {
      setSpecificationsError(" Vui lòng không để title hoặc content trống");
      isValid = false;
    }
    // console.log("description", description)
    // console.log("description1", description1)
    // console.log("productData", productData)
    // console.log("updatedProductData", updatedProductData)
    if (isValid) {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/api/products/create`,
          updatedProductData,
          config
        )
        .then((response) => {
          console.log("Sản phẩm đã được tạo thành công:", response.data);
          setShow(true);
        })
        .catch((error) => {
          console.error("Lỗi khi tạo sản phẩm:", error);
          setErrorMessage("Đã xảy ra lỗi khi tạo sản phẩm.");
          setSuccessMessage("");
          setShowPopup(true);
        });
    }
  };

  const [newSpec, setNewSpec] = useState({
    title: "",
    content: "",
  });

  const [data, setData] = useState([{ title: "", content: "" }]);

  const handleAddRow = () => {
    setData([...data, { title: "", content: "" }]);
  };

  const handleInputChanges = (index, columnName, value) => {
    const newData = [...data];
    newData[index][columnName] = value;
    setData(newData);
  };
  const filterConfig = {
    disallowedContent: "i",
  };

  const handleClose = () => {
    navigate(`/admin/products/list?page=${page}`);
    setShow(false);
  };
  return (
    <div className="min-h-screen bg-gray-50 ">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>THÀNH CÔNG</Modal.Title>
        </Modal.Header>
        <Modal.Body>SẢN PHẨM ĐÃ ĐƯỢC TẠO THÀNH CÔNG</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 overflow-y-auto">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Tạo mới sản phẩm
            </h1>
            <p className="text-gray-600 mt-1">Thêm sản phẩm mới vào hệ thống</p>
          </div>
          <button
            onClick={() => navigate(`/admin/products/list?page=${page}`)}
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          >
            ← Quay lại danh sách
          </button>
        </div>
      </div>

      <div className="  overflow-y-auto h-[calc(100vh-100px)] px-20 py-4">
        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  Thông báo
                </h3>
                <button
                  onClick={() => setShowPopup(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>
              {successMessage && (
                <div className="text-green-600 text-sm">{successMessage}</div>
              )}
            </div>
          </div>
        )}

        <form
          className="space-y-8"
          encType="multipart/form-data"
          disabled={isFormDisabled}
        >
          {/* Thông tin cơ bản */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Thông tin cơ bản
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* SKU */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  SKU <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={sku}
                  onChange={handleNameChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Nhập mã SKU"
                />
                {skuError && (
                  <div className="text-red-500 text-sm mt-1">{skuError}</div>
                )}
              </div>

              {/* Thời gian bảo hành */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Thời gian bảo hành <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={warrantyPeriod}
                  onChange={handleNameChange11}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="VD: 12 tháng"
                />
                {warrantyPeriodError && (
                  <div className="text-red-500 text-sm mt-1">
                    {warrantyPeriodError}
                  </div>
                )}
              </div>
            </div>

            {/* Tên sản phẩm */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tên sản phẩm <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                rows="2"
                value={productName}
                onChange={handleNameChange1}
                placeholder="Nhập tên sản phẩm"
              />
              {productNameError && (
                <div className="text-red-500 text-sm mt-1">
                  {productNameError}
                </div>
              )}
            </div>

            {/* Mô tả */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mô tả sản phẩm <span className="text-red-500">*</span>
              </label>
              <div className="border border-gray-300 rounded-lg overflow-hidden">
                <CKEditor
                  editor={ClassicEditor}
                  data={description}
                  onChange={handleEditorChange}
                  config={{
                    extraPlugins: [CustomUploadAdapter],
                    contentFilter: filterConfig,
                  }}
                  onReady={(editor) => {
                    editor.plugins.get("FileRepository").createUploadAdapter = (
                      loader
                    ) => {
                      return new CustomUploadAdapter(loader);
                    };
                    editorRef.current = editor;
                  }}
                />
              </div>
              {descriptionError && (
                <div className="text-red-500 text-sm mt-1">
                  {descriptionError}
                </div>
              )}
            </div>

            {/* Link Video */}
            <div className="mt-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Link video
              </label>
              <textarea
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                rows="2"
                value={urlvideo}
                onChange={handleNameChange13}
                placeholder="Nhập link video YouTube hoặc URL khác"
              />
            </div>
          </div>

          {/* Giá và số lượng */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Giá và số lượng
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Giá gốc */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Giá gốc (VND) <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={originalPrice}
                  value={originalPrice}
                  onChange={(e) => handleInput(e, setoriginalPrice)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {originalPriceError && (
                  <div className="text-red-500 text-sm mt-1">
                    {originalPriceError}
                  </div>
                )}
              </div>

              {/* Giá bán */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Giá bán (VND) <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={sellingPrice}
                  value={sellingPrice}
                  onChange={(e) => handleInput(e, setsellingPrice)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {sellingPriceError && (
                  <div className="text-red-500 text-sm mt-1">
                    {sellingPriceError}
                  </div>
                )}
              </div>

              {/* Giá bán sỉ */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Giá bán sỉ (VND) <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={retailprice}
                  value={retailprice}
                  onChange={(e) => handleInput(e, setretailprice)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {retailpriceError && (
                  <div className="text-red-500 text-sm mt-1">
                    {retailpriceError}
                  </div>
                )}
              </div>

              {/* Số lượng */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Số lượng <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder={quantity}
                  value={quantity}
                  onInput={(e) => handleInput1(e, setquantity)}
                  onKeyPress={handleKeyPress1}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
                {quantityError && (
                  <div className="text-red-500 text-sm mt-1">
                    {quantityError}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Phân loại */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Phân loại sản phẩm
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Loại sản phẩm */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Loại sản phẩm <span className="text-red-500">*</span>
                </label>
                <select
                  value={categoryId}
                  onChange={handleNameChange67}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white"
                >
                  <option value="">Chọn loại sản phẩm</option>
                  {category.map((category) => (
                    <option
                      key={category.categoryID}
                      value={category.categoryID}
                    >
                      {category.name}
                    </option>
                  ))}
                </select>
                {categoryIdError && (
                  <div className="text-red-500 text-sm mt-1">
                    {categoryIdError}
                  </div>
                )}
              </div>

              {/* Hãng sản xuất */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Hãng sản xuất <span className="text-red-500">*</span>
                </label>
                <select
                  value={brandId}
                  onChange={handleNameChangev}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors bg-white"
                >
                  <option value="">Chọn hãng sản xuất</option>
                  {brands.map((brands) => (
                    <option key={brands.idBrand} value={brands.idBrand}>
                      {brands.name}
                    </option>
                  ))}
                </select>
                {brandIdError && (
                  <div className="text-red-500 text-sm mt-1">
                    {brandIdError}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Hình ảnh */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Hình ảnh sản phẩm
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Ảnh chính */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ảnh chính
                </label>
                <div
                  onDrop={handleFileDrop}
                  onDragOver={handleDragOver}
                  className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 transition-colors"
                >
                  <label className="cursor-pointer block">
                    <input
                      type="file"
                      multiple
                      onChange={handleFileSelect}
                      className="hidden"
                    />
                    <div className="text-gray-500">
                      <svg
                        className="mx-auto h-12 w-12 mb-4"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-sm">
                        Chọn ảnh hoặc kéo và thả ảnh vào đây
                      </span>
                    </div>
                  </label>
                  {base64Image && (
                    <div className="mt-4">
                      <img
                        src={base64Image}
                        alt="Preview"
                        className="w-20 h-20 object-cover rounded-lg mx-auto border border-gray-200"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Ảnh phụ */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ảnh phụ
                </label>
                <div
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 transition-colors"
                >
                  <label className="cursor-pointer block">
                    <input
                      type="file"
                      multiple
                      onChange={handleFileSelects}
                      className="hidden"
                    />
                    <div className="text-gray-500">
                      <svg
                        className="mx-auto h-12 w-12 mb-4"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-sm">
                        Chọn nhiều ảnh hoặc kéo và thả ảnh vào đây
                      </span>
                    </div>
                  </label>
                  {selectedFiles.length > 0 && (
                    <div className="mt-4 flex flex-wrap gap-2 justify-center">
                      {selectedFiles.map((file, index) => (
                        <div key={index} className="relative">
                          {base64Images[index] && (
                            <img
                              src={base64Images[index]}
                              alt="Preview"
                              className="w-16 h-16 object-cover rounded-lg border border-gray-200"
                            />
                          )}
                          <button
                            type="button"
                            onClick={() => handleClearFile(index)}
                            className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full text-xs flex items-center justify-center hover:bg-red-600 transition-colors"
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Cài đặt */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Cài đặt sản phẩm
            </h2>

            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={status}
                  onChange={handleChange}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label className="ml-3 text-sm font-medium text-gray-700">
                  Trạng thái hoạt động
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={contactToPurchase}
                  onChange={handleChange1}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label className="ml-3 text-sm font-medium text-gray-700">
                  Hiển thị giá
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={bestseller}
                  onChange={handleChange122}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label className="ml-3 text-sm font-medium text-gray-700">
                  Sản phẩm nổi bật
                </label>
              </div>
            </div>
          </div>

          {/* Thông số kỹ thuật */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6 pb-3 border-b border-gray-200">
              Thông số kỹ thuật
            </h2>

            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4 font-medium text-gray-700">
                      Tên thông số
                    </th>
                    <th className="text-left py-3 px-4 font-medium text-gray-700">
                      Giá trị
                    </th>
                  </tr>
                </thead>
                <tbody className="space-y-2">
                  {data.map((element, index) => (
                    <tr key={index} className="border-b border-gray-100">
                      <td className="py-3 px-4">
                        <textarea
                          type="text"
                          name="title"
                          value={element.title}
                          onChange={(e) =>
                            handleInputChanges(index, "title", e.target.value)
                          }
                          placeholder="Nhập tên thông số"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                          rows="2"
                        />
                      </td>
                      <td className="py-3 px-4">
                        <textarea
                          type="text"
                          name="content"
                          value={element.content}
                          onChange={(e) =>
                            handleInputChanges(index, "content", e.target.value)
                          }
                          placeholder="Nhập giá trị"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                          rows="2"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {SpecificationsError && (
                <div className="text-red-500 text-sm mt-2">
                  {SpecificationsError}
                </div>
              )}
            </div>

            <button
              type="button"
              onClick={handleAddRow}
              className="mt-4 inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              + Thêm thông số
            </button>
          </div>

          {/* Submit button */}
          <div className="flex justify-end space-x-4 pt-6">
            <button
              type="button"
              onClick={() => navigate(`/admin/products/list?page=${page}`)}
              className="px-6 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              Hủy
            </button>
            <button
              type="button"
              onClick={handleCreate}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm"
            >
              Tạo mới sản phẩm
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProducts;
